import { app, assetUrl } from '../config.js';

/**
 * 分享内容卡片。
 * 标题和描述都按纯文本渲染（React 默认转义），不解析 HTML ——
 * 这些字段来自别人发来的链接，属于不可信输入。
 */
export default function ShareCard({ share }) {
  const title = share?.title || `${app.name} · 分享内容`;
  const description = share?.description || `在「${app.name}」App 中查看完整内容`;
  const image = share?.image;
  const author = share?.author;

  return (
    <article className="share-card">
      {image ? (
        <img className="share-card__thumb" src={image} alt="" loading="lazy" />
      ) : (
        <img className="share-card__thumb" src={assetUrl('img/app-icon.png')} alt="" />
      )}

      <div className="share-card__body">
        <h2 className="share-card__title">{title}</h2>
        <p className="share-card__desc">{description}</p>
        {author ? <span className="share-card__author">{author}</span> : null}
      </div>
    </article>
  );
}
